<template>
  <mounting-portal append :mount-to="'#dialog-root'">
    <div
      class="dialog"
      data-a11y-dialog="main"
      ref="modal"
      aria-labelledby="modal-content"
      aria-hidden="true"
    >
      <div class="dialog-overlay" data-a11y-dialog-hide></div>
      <div class="dialog-content d-flex flex-column" role="document">
        <button
          type="button"
          class="dialog-close btn btn--secondary"
          data-a11y-dialog-hide
        >
          {{ i18n.close_modal }}
        </button>

        <div class="p-3 p-md-4 d-flex flex-column mh-0 h-100">
          <h2 class="dialog__heading" v-if="title">
            {{ title }}
          </h2>

          <div
            class="cms-content dialog__content"
            v-if="content"
            v-html="content"
          ></div>
        </div>
      </div>
    </div>
  </mounting-portal>
</template>

<script>
import A11yDialog from 'a11y-dialog';
import { MountingPortal } from 'portal-vue';

export default {
  props: {
    open: Boolean,
    title: String,
    content: String,
  },

  components: {
    MountingPortal,
  },

  data() {
    return {
      dialog: null,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.dialog = new A11yDialog(this.$refs.modal, '#app');

      const html = document.documentElement;

      this.dialog.on('hide', () => {
        // Restore store state for modal...
        this.$store.commit('setModalOpen', false);
        this.$store.commit('setModalTitle', null);
        this.$store.commit('setModalContent', null);

        this.$emit('hide');

        // Re-enable body scroll
        html.style.overflowY = '';
      });

      this.dialog.on('show', () => {
        // Disable body scroll
        html.style.overflowY = 'hidden';
      });
    });
  },

  watch: {
    open(openState) {
      if (openState) {
        this.dialog.show();
      }
    },
  },
};
</script>

<style>
.dialog[aria-hidden="true"] {
  display: none;
}

/**
 * 1. Make the dialog container, and its child overlay spread across
 *    the entire window.
 */
.dialog-container,
.dialog-overlay {
  position: fixed; /* 1 */
  top: 0; /* 1 */
  right: 0; /* 1 */
  bottom: 0; /* 1 */
  left: 0; /* 1 */
}

/**
 * 1. Make sure the dialog container and all its descendants sits on
 *    top of the rest of the page.
 * 2. Make the dialog container a flex container to easily center the
 *    dialog.
 */
.dialog-container {
  z-index: 2; /* 1 */
  display: flex; /* 2 */
}

/**
 * 1. Make sure the dialog container and all its descendants are not
 *    visible and not focusable when it is hidden.
 */
.dialog-container[aria-hidden='true'] {
  display: none; /* 1 */
}

/**
 * 1. Make the overlay look like an overlay.
 */
.dialog-overlay {
  background-color: rgba(43, 46, 56, 0.9); /* 1 */
  z-index: 10;
}

/**
 * 1. Vertically and horizontally center the dialog in the page.
 * 2. Make sure the dialog sits on top of the overlay.
 * 3. Make sure the dialog has an opaque background.
 */
.dialog-content {
  margin: auto; /* 1 */
  z-index: 11; /* 2 */
  background-color: white; /* 3 */

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: calc(100% - 2rem);
  width: 100%;
  max-height: calc(100% - 2rem);
}

.dialog__heading {
  margin: 0 0 1rem;
  padding-right: 8rem;
  flex: 0 0 auto;
}

.dialog__content {
  flex: 1 1 auto;
  overflow-y: auto;
  max-height: calc(100vh - 2rem);
}

.dialog-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

@media (max-width: 767px) {
  .dialog-close {
    height: 2rem;
  }
}

@media (min-width: 40rem) {
  .dialog-content {
    max-width: 38rem;
  }
}

@media (min-width: 768px) {
  .dialog__heading {
    margin-bottom: 1.5rem;
  }

  .dialog-close {
    top: 1.5rem;
    right: 1.5rem;
  }
}
</style>
